/**
 * eventBus — tiny app-wide event bus using window CustomEvent.
 * Used to notify sibling widgets (e.g. Reading Progress panel) that a
 * long-running action just completed, without threading state through
 * every intermediate route.
 */
export const emit = (name, detail = {}) => {
  try {
    window.dispatchEvent(new CustomEvent(`zazu:${name}`, { detail }));
  } catch (_e) { /* SSR / private-mode guard */ }
};

export const on = (name, handler) => {
  const wrapped = (ev) => handler(ev.detail || {});
  window.addEventListener(`zazu:${name}`, wrapped);
  return () => window.removeEventListener(`zazu:${name}`, wrapped);
};
